<template>
  <ion-app>
    <ion-router-outlet />
  </ion-app>
</template>

<script setup lang="ts">
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { usePwaInstallPrompt } from '@/composables/pwa/usePwaInstallPrompt'

usePwaInstallPrompt()
</script>
